module.exports = __webpack_public_path__ + "static/media/b2.dc805b05.png";